export { default } from '@/features/settings/pages/PrinterManagementPage'
